const NOTICE_MESSAGES = new Map([
  [
    "unavailable",
    "Some products were not available and were not added to your cart.",
  ],
]);

export const noticeMessageFor = (code) => NOTICE_MESSAGES.get(code) ?? null;

export const withoutNotice = (search) => {
  const params = new URLSearchParams(search);
  params.delete("notice");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};
